module.exports = __webpack_public_path__ + "static/media/Phan_Nhat_Huy.c7358cd3.jpg";